// frontend/src/components/MessageItem.tsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface Msg {
    id: string | number;
    from: 'user' | 'bot' | 'error';
    text: string;
}

interface MessageItemProps {
    message: Msg;
}

export function MessageItem({ message }: MessageItemProps): React.JSX.Element {
    const isUser = message.from === 'user';
    const isError = message.from === 'error';

    // Determinar clases de Bootstrap para alineación y color
    const alignmentClass = isUser ? 'text-end' : 'text-start';

    // Usa clases personalizadas para las burbujas
    const typeClass = isUser ? 'user-bubble' : (isError ? 'error-bubble' : 'bot-bubble');
    const bubbleClasses = `message-bubble ${typeClass}`;

    return (
        <div className={`message-container ${alignmentClass}`}>
            <div className={bubbleClasses}>
                <ReactMarkdown
                    children={message.text}
                    remarkPlugins={[remarkGfm]}
                    components={{
                        a: ({ node, children, ...props }) => (
                            <a target="_blank" rel="noopener noreferrer" {...props}>
                                {children}
                            </a>
                        )
                    }}
                />
            </div>
        </div>
    );
}

/*
NOTA CSS (Opcional):
Puedes definir clases .message-bubble, .user-bubble, .bot-bubble para personalizar aún más los estilos.
*/